import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import LocalStorage from "../../services/LocalStorage";
import {
  FIRST_TIME_AFTER_VERSION_UPDATE,
  TASK_MODEL_VERSION,
} from "../../utils/CONSTANTS";

const storedTaskModelVersion = LocalStorage.getData(TASK_MODEL_VERSION) || "v6";
const storedFirstTimeAfterVersionUpdate =
  LocalStorage.getData(FIRST_TIME_AFTER_VERSION_UPDATE) ?? true;

export const slice = createSlice({
  name: "AppState",
  initialState: {
    taskModelVersion: storedTaskModelVersion,
    firstTimeAfterVersionUpdate: storedFirstTimeAfterVersionUpdate,
  },
  reducers: {
    setTaskModelVersion: (state, action) => {
      state.taskModelVersion = action.payload;
      LocalStorage.storeData(TASK_MODEL_VERSION, action.payload);
    },
    setFirstTimeAfterUpdate: (state, action) => {
      state.firstTimeAfterVersionUpdate = action.payload;
      LocalStorage.storeData(FIRST_TIME_AFTER_VERSION_UPDATE, action.payload);
    },
  },
});

export const { setTaskModelVersion, setFirstTimeAfterUpdate } = slice.actions;

export const useTaskModelVersion = () =>
  useSelector((state) => state.AppState.taskModelVersion);

export const useIsV6 = () =>
  useSelector((state) => state.AppState.taskModelVersion === "v6");

export const useIsFirstTimeAfterVersionUpdate = () =>
  useSelector((state) => state.AppState.firstTimeAfterVersionUpdate);

export default slice.reducer;
